import React from "react";
import { formatComma } from "./dataHelpers/formatters";
import H from "../components/H";

const { COUNTY_CLASSES_POP } = require("./constants");

const genTextClassPop = (countyClass) => {
  /**
   * Generates a text fragment summarizing the population range of a county class.
   *
   * @param {string} county class name. Eg. '1', '2', '2-A', etc.
   * @return {string} text fragment about county. Eg. "between 500,000 and 799,999 people"
   */
  const { popMin, popMax } = COUNTY_CLASSES_POP[countyClass];
  let popText;
  const cleanPopMin = formatComma(popMin);
  const cleanPopMax = formatComma(popMax);
  if (popMin === 0) {
    popText = (
      <span>
        less than <H>{cleanPopMax}</H>
      </span>
    );
  } else if (!popMax) {
    popText = (
      <span>
        greater than <H>{cleanPopMin}</H>
      </span>
    );
  } else {
    popText = (
      <span>
        between <H>{cleanPopMin}</H> and <H>{cleanPopMax}</H>
      </span>
    );
  }
  return popText;
};

export default genTextClassPop;
